module.exports = __webpack_public_path__ + "media/images/emoticons/updown-75c699d3c0e1e9c360120d5a1b2c8357.gif";